/**
 * Created by rickborst on 22/08/2017.
 */

import _ from 'lodash';

import Row from './epgsection/row';

class EpgSection {

    /**
     * Constructs the object.
     *
     * @param {Object} options - Options object.
     */
    constructor (options = {}) {

        this.start = options.start || null;
        this.end = options.end || null;
        this.rows = _.map(options.rows || [], entry => {
            return new Row(entry);
        });
    }
}

export default EpgSection;


// WEBPACK FOOTER //
// ./src/js/models/epgsection.js